import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { NgSelectConfig } from '@ng-select/ng-select';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'minoteriedusenegal.angular';

  constructor(private updates: SwUpdate, private config: NgSelectConfig) {
    if (this.updates.isEnabled) {
      this.updates.versionUpdates
        .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
        .subscribe(() => {
          this.updates.activateUpdate().then(() => document.location.reload());
        });
    }

    this.config.notFoundText = 'Aucun résultat';
    this.config.appendTo = 'body';
    // this.config.placeholder="Rechercher / Filtrer"
    this.config.disableVirtualScroll=false
    // set the bindValue to global config when you use the same
    // bindValue in most of the place.
    // You can also override bindValue for the specified template
    // by defining `bindValue` as property
    // Eg : <ng-select bindValue="some-new-value"></ng-select>
    // this.config.bindValue = 'value';
  }
}
